import React, { useEffect, useState } from "react";

import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  CardTitle,
} from "reactstrap";
import InputMask from "react-input-mask";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import classnames from "classnames";
import { Link, useNavigate } from "react-router-dom";
import Spinners from "components/Common/Spinner";
import Select from "react-select";
import { useParams } from "react-router-dom";
import Config from "config";
const formDossierSouscription = () => {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  let { investisseur_id } = useParams();
  const [loading, setLoading] = useState(true);
  const [wait, setWait] = useState(400);
  const navigate = useNavigate();
  const token = localStorage.getItem("auth_token");
  function getCurrentDate() {
    const currentDate = new Date();

    const day = currentDate.getDate();
    const month = currentDate.getMonth() + 1;
    const year = currentDate.getFullYear();

    const formattedDay = day < 10 ? `0${day}` : day;
    const formattedMonth = month < 10 ? `0${month}` : month;

    const formattedDate = `${formattedDay}/${formattedMonth}/${year}`;

    return formattedDate;
  }

  const currentDateFormatted = getCurrentDate();

  const [selectedDateSignature, setSelectedDateSignature] =
    useState(currentDateFormatted);

  const [selectedMontant, setSelectedMontant] = useState("");
  const handleMontantChange = (e) => {
    setSelectedMontant(e.target.value);
  };
  const [selectedLieuSignature, setSelectedLieuSignature] = useState("");
  const handleLieuChange = (e) => {
    setSelectedLieuSignature(e.target.value);
  };
  const [selectedComplement, setSelectedComplement] = useState("");
  const handleComplementChange = (e) => {
    setSelectedComplement(e.target.value);
  };
  const [selectedIban, setSelectedIban] = useState("");
  const handleIbanChange = (e) => {
    setSelectedIban(e.target.value);
  };
  const [selectedBic, setSelectedBic] = useState("");
  const handleBicChange = (e) => {
    setSelectedBic(e.target.value);
  };
  /*************************   Taux d'apport  *******************************/
  const [selectedTaux, setSelectedTaux] = useState("");
  const [tauxData, setSelectedTauxData] = useState({ data: [] });
  const handleTauxChange = (e) => {
    setSelectedTaux(e);
  };
  const getTaux = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/reservations/taux_apports?investisseur_id=${investisseur_id}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((taux) => {
          setSelectedTauxData(taux);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTauxOptions = () => {
    return [
      {
        options: tauxData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /******************************* END Taux d'apport *******************************************/
  /******************************* Mode de règlement *******************************************/
  const [selectedMode, setSelectedMode] = useState("");
  const [modeData, setModeData] = useState({ data: [] });
  const handleModeChange = (e) => {
    setSelectedMode(e);
  };

  const getMode = async () => {
    try {
      await fetch(
        `https://www.fluxod.com/${api}/reservations/mode_reglements`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((mode) => {
          setModeData(mode);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderModeOptions = () => {
    return [
      {
        options: modeData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /******************************* END Mode de règlement *******************************************/
  useEffect(() => {
    if (!loading) {
      getTaux();
      getMode();
    }
  }, [loading]);
  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    if (selectedTaux?.value == undefined) {
      toast.error("Le taux ne peut pas être vide");
    } else if (selectedMode?.value == undefined) {
      toast.error("Le mode de règlement ne peut pas être vide");
    } else {
      try {
        setWait(20000);
        const response = await fetch(
          `https://www.fluxod.com/${api}/investisseurs/submit_dossier_souscription`,
          {
            method: "PATCH",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              investisseur_id: investisseur_id,
              montant: selectedMontant,
              taux_apport_id: selectedTaux?.value,
              complement_dinformations: selectedComplement,
              lieu_de_signature: selectedLieuSignature,
              date_de_signature: selectedDateSignature,
              mode_reglement_id: selectedMode?.value,
              iban: selectedIban,
              bic: selectedBic,
            }),
          }
        );

        if (response.ok) {
          console.log("PATCH request successful");
          const responseData = await response.json();
          setTimeout(() => {
            toast.success(responseData?.message);
          }, 400);
          setLoading(false);
          setWait(0);
          navigate(
            `${backUrl}/reservations_en_cours/${responseData?.reservation_id}`
          );
        } else {
          console.error("PATCH request failed");
          const responseData = await response.json();

          if (responseData && responseData.reservation_validation) {
            // Si le champ "contact_validation" est présent dans la réponse JSON
            const errors =
              responseData?.contact_validation ||
              responseData?.investisseur_validation;

            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="d-flex align-items-center">
                    <h5
                      className="mb-4 card-title flex-grow-1"
                      style={{ fontWeight: "bold" }}
                    >
                      <Link
                        to={`${backUrl}/investisseurs/`}
                        style={{
                          color: "#3c88c8",
                          textDecoration: "underline !important",
                        }}
                      >
                        Dossier de souscription
                      </Link>{" "}
                      <i className="bx bx-caret-right"></i> Nouvel
                      enregistrement
                    </h5>
                  </div>
                  <div className="wizard clearfix">
                    <div className=" clearfix">
                      <Card>
                        <TabPane tabId={1}>
                          <Form>
                            <>
                              <Row>
                                <Col sm="12">
                                  <Card className="mb-4">
                                    <CardTitle
                                      tag="h5"
                                      style={{
                                        paddingLeft: "10px",
                                        paddingTop: "10px",
                                      }}
                                    >
                                      {" "}
                                      Réservation
                                    </CardTitle>
                                    {!loading ? (
                                      <>
                                        <CardBody>
                                          <Row>
                                            <Col
                                              xs={12}
                                              md={4}
                                              className="col-md-4 mb-2"
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "11em",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  Taux d'apport :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col
                                              xs={12}
                                              md={8}
                                              className="mb-2 col-md-8"
                                            >
                                              <Select
                                                defaultValue={selectedTaux}
                                                onChange={handleTauxChange}
                                                options={renderTauxOptions()}
                                                isClearable={true}
                                                className="select2"
                                              />
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col
                                              xs={12}
                                              md={4}
                                              className="col-md-4 mb-2"
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "11em",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  Montant (€):
                                                </span>
                                              </i>
                                            </Col>
                                            <Col
                                              xs={12}
                                              md={8}
                                              className="mb-2 col-md-8"
                                            >
                                              <input
                                                className="form-control"
                                                required
                                                onChange={handleMontantChange}
                                              />
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col
                                              xs={12}
                                              md={4}
                                              className="col-md-4 mb-2"
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "11em",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  Mode de règlement :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col
                                              xs={12}
                                              md={8}
                                              className="mb-2 col-md-8"
                                            >
                                              <Select
                                                defaultValue={selectedMode}
                                                onChange={handleModeChange}
                                                options={renderModeOptions()}
                                                isClearable={true}
                                                className="select2"
                                              />
                                            </Col>
                                          </Row>
                                          {selectedMode?.value == 3 ? (
                                            <>
                                              <Row>
                                                <Col
                                                  xs={12}
                                                  md={4}
                                                  className="col-md-4 mb-2"
                                                  style={{
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  <i
                                                    style={{
                                                      color: "#9d9c9c",
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        display: "inline-block",
                                                        width: "8em",
                                                        whiteSpace: "nowrap",
                                                        paddingTop: "10px",
                                                      }}
                                                    >
                                                      IBAN :
                                                    </span>
                                                  </i>
                                                </Col>
                                                <Col
                                                  xs={12}
                                                  md={8}
                                                  className="mb-2 col-md-8"
                                                >
                                                  <input
                                                    className="form-control"
                                                    defaultValue={selectedIban}
                                                    required
                                                    onChange={handleIbanChange}
                                                  />
                                                </Col>
                                              </Row>
                                              <Row>
                                                <Col
                                                  xs={12}
                                                  md={4}
                                                  className="col-md-4 mb-2"
                                                  style={{
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  <i
                                                    style={{
                                                      color: "#9d9c9c",
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        display: "inline-block",
                                                        width: "8em",
                                                        whiteSpace: "nowrap",
                                                        paddingTop: "10px",
                                                      }}
                                                    >
                                                      BIC :
                                                    </span>
                                                  </i>
                                                </Col>
                                                <Col
                                                  xs={12}
                                                  md={8}
                                                  className="mb-2 col-md-8"
                                                >
                                                  <input
                                                    className="form-control"
                                                    defaultValue={selectedBic}
                                                    required
                                                    onChange={handleBicChange}
                                                  />
                                                </Col>
                                              </Row>
                                            </>
                                          ) : null}
                                          <Row>
                                            <Col
                                              xs={12}
                                              md={4}
                                              className="col-md-4 mb-2"
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "8em",
                                                    whiteSpace: "nowrap",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  Date de signature :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col
                                              xs={12}
                                              md={8}
                                              className="mb-2 col-md-8"
                                            >
                                              <InputMask
                                                mask="99/99/9999"
                                                value={selectedDateSignature}
                                                className="form-control input-color"
                                                onChange={(dateString) => {
                                                  setSelectedDateSignature(
                                                    dateString.target.value
                                                  );
                                                }}
                                              />
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col
                                              xs={12}
                                              md={4}
                                              className="col-md-4 mb-2"
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "8em",
                                                    whiteSpace: "nowrap",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  Lieu de signature :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col
                                              xs={12}
                                              md={8}
                                              className="mb-2 col-md-8"
                                            >
                                              <input
                                                className="form-control"
                                                defaultValue={
                                                  selectedLieuSignature
                                                }
                                                required
                                                onChange={handleLieuChange}
                                              />
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col
                                              xs={12}
                                              md={4}
                                              className="col-md-4 mb-2"
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "11em",
                                                    paddingRight: "10px",
                                                    whiteSpace: "pretty",
                                                  }}
                                                >
                                                  Complément d'informations :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col
                                              xs={12}
                                              md={8}
                                              className="mb-2 col-md-8"
                                            >
                                              <textarea
                                                className="form-control"
                                                defaultValue={
                                                  selectedComplement
                                                }
                                                style={{
                                                  width: "100%",
                                                  resize: "vertical",
                                                }}
                                                onChange={
                                                  handleComplementChange
                                                }
                                              ></textarea>
                                            </Col>
                                          </Row>
                                          <Row className="mt-1">
                                            <div
                                              className="actions clearfix"
                                              style={{ textAlign: "center" }}
                                            >
                                              <button
                                                className="btn btn-info"
                                                onClick={handleSubmit}
                                              >
                                                Créer
                                              </button>
                                              &nbsp;&nbsp;
                                              <Link
                                                className="btn btn-info"
                                                to={`${backUrl}/investisseurs/${investisseur_id}`}
                                              >
                                                Retour vers l'investisseur
                                              </Link>
                                            </div>
                                          </Row>
                                        </CardBody>
                                      </>
                                    ) : (
                                      <Spinners
                                        setLoading={setLoading}
                                        setWait={wait}
                                      />
                                    )}
                                  </Card>
                                </Col>
                              </Row>
                            </>
                          </Form>
                        </TabPane>
                      </Card>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <ToastContainer />
    </React.Fragment>
  );
};

export default formDossierSouscription;
